const destinations = [
  {
    name: 'messenger',
    label: 'Messenger',
  },
  {
    name: 'web',
    label: 'Web',
  },
  {
    name: 'app',
    label: 'App',
  },
];

export default destinations;
